import React from 'react';
import { useParams } from 'react-router-dom';
import { CatalogForm } from '../../../components/CatalogForm/CatalogForm';
import { CfdiFiscalRegimenService } from '../../../services/CfdiFiscalRegimenService';
import { Validators } from '../../../components/CatalogForm/validators';

const formFields = [
  {
    name: 'cfdi_regimen_clave',
    label: 'Clave',
    type: 'text',
    col: 4,
    placeholder: 'Ej. 601',
    validators: [
      Validators.required("La clave es obligatoria")
    ],
  },
  {
    name: 'cfdi_regimen_nombre',
    label: 'Nombre del Régimen',
    type: 'text',
    col: 8,
    placeholder: 'Ej. General de Ley Personas Morales',
    validators: [
      Validators.required("El nombre del régimen es obligatorio")
    ],
  },
];

export const CfdiFiscalRegimenForm = () => {
  const { id } = useParams();

  const handleLoadData = async (recordId) => {
    return await CfdiFiscalRegimenService.obtenerPorId(recordId);
  };

  const handleSubmit = async (values) => {
    return await CfdiFiscalRegimenService.guardar(values);
  };

  return (
    <CatalogForm
      title="Régimen Fiscal CFDI"
      subtitle="Administración de regímenes fiscales para CFDI"
      fields={formFields}
      id={id}
      loadData={handleLoadData}
      onSubmit={handleSubmit}
      backUrl="/Catalogo/CfdiFiscalRegimenes"
    />
  );
};

export default CfdiFiscalRegimenForm;
